import { seedArtworks } from "../data/artworks";
import type { Artwork } from "../types/artwork";

export async function loadArtworks(): Promise<Artwork[]> {
  try {
    const response = await fetch("/api/artworks", {
      headers: { accept: "application/json" }
    });
    if (!response.ok) throw new Error(`Artwork API returned ${response.status}`);
    const data = (await response.json()) as { artworks?: Artwork[] };
    if (!Array.isArray(data.artworks)) throw new Error("Artwork API response missing artworks");
    return data.artworks;
  } catch {
    return seedArtworks;
  }
}

export function formatArtworkPrice(artwork: Artwork): string {
  if (artwork.pricePence === null) return "Price on enquiry";
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: artwork.currency,
    maximumFractionDigits: 0
  }).format(artwork.pricePence / 100);
}

export function formatAvailability(artwork: Artwork): string {
  if (artwork.stockStatus === "instock") return "Available";
  if (artwork.stockStatus === "outofstock") return "Sold";
  if (artwork.stockStatus === "onbackorder") return "Reserved";
  return "Availability on enquiry";
}
